import { render, staticRenderFns } from "./GatewayPendingTransaction.vue?vue&type=template&id=414d2d6c"
import script from "./GatewayPendingTransaction.vue?vue&type=script&lang=js"
export * from "./GatewayPendingTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports